import _ from 'lodash';

import URC from 'ui-react-common';
import * as types from './action-types';

const api = URC.services.coreAPIInstance;
const { UserService } = URC.services;

const apply = (data) => ({
    asyncAction: () =>
        api
            .apply(data)
            .then((response) => {
                const user = _.get(response, 'data.user');
                user && UserService.set(user);
                // Used in Google Tag Manager dataLayer
                const eventId = `${Math.random().toString(36).substring(2, 15)}_${Date.now()}`;
                const loanId = user && user.loanId || '';
                loanId && window.dataLayer.push({
                    event: 'SUBMIT_APPLICATION',
                    loanId,
                    event_id: eventId
                });
                api.sendEvent('SUBMIT_APPLICATION', eventId).catch((error) => {
                    console.error('Error sending event:', error);
                });
                return response;
            })
            .catch((error) => {
                const user = _.get(error, 'data.user');
                user && UserService.set(user);
                throw error;
            }),
    type: types.APPLY,
});

const getVendorConfig = () => ({
    asyncAction: () =>
        api
            .getVendorConfig()
            .then((response) => response)
            .catch((error) => {
                throw error;
            }),
    type: types.VENDOR_CONFIG,
});

const clearApplication = () => ({
    type: types.CLEAR_APPLICATION,
});

export default {
    apply,
    getVendorConfig,
    clearApplication
};
